/* import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { getSettings } from "../../services/settingsService";
import { doLogout } from "../../services/authService";
import Menu from "../../components/menu/Menu";

export default function Settings() {
  const history = useHistory();

  const [settings, setSettings] = useState({ email: "" });
  const [error, setError] = useState("");
  useEffect(() => {
    const token = localStorage.getItem("token");

    getSettings(token)
      .then((response) => {
        setSettings(response);
      })
      .catch((err) => {
        if (err.response.status === 401) return history.push("/");
        setError(err.response ? err.response.data : err.message);
      });
  }, []);

  function handleLogout(e) {
    const token = localStorage.getItem("token");
    doLogout(token)
      .then((response) => {
        localStorage.removeItem("token");
        history.push("/");
      })
      .catch((err) => {
        setError(err.response ? err.response.data : err.message);
      });
  }

  return (
    <>
      <Menu />
      <main>
        <section className="vh-lg-100 mt-5 mt-lg-0 bg-soft d-flex align-items-center">
          <div className="container">
            <p className="text-center">{settings.email}</p>
            {error && <div className="alert alert-danger">{error}</div>}
          </div>
        </section>
      </main>
    </>
  );
}
*/

import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { getSettings, updateSettings } from "../../services/settingsService";
import { getEmpresa, updateEmpresa } from "../../services/empresaService";
import Menu from "../../components/menu/Menu";

function Settings() {
  const inputEmail = useRef("");
  const inputNewPassword = useRef("");
  const inputConfirmPassword = useRef("");

  const inputNomeEmpresa = useRef("");
  const inputMorada = useRef("");
  const inputCodigoPostal = useRef("");
  const inputLocalidade = useRef("");

  const history = useHistory();

  const [error, setError] = useState("");

  const [success, setSuccess] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("token");
    getSettings(token)
      .then((response) => {
        inputEmail.current.value = response.email;
      })
      .catch((err) => {
        if (err.response && err.response.status === 401)
          return history.push("/");

        setError(err.response ? err.response.data : err.message);
      });

    getEmpresa(token)
      .then((response) => {
        inputNomeEmpresa.current.value = response.designacao;
        inputMorada.current.value = response.morada;
        inputCodigoPostal.current.value = response.codpostal;
        inputLocalidade.current.value = response.localidade;
      })
      .catch((err) => {
        if (err.response && err.response.status === 401)
          return history.push("/");

        setError(err.response ? err.response.data : err.message);
      });
  }, []);

  function handleFormSubmit(event) {
    event.preventDefault();

    if (
      (inputNewPassword.current.value || inputConfirmPassword.current.value) &&
      inputNewPassword.current.value !== inputConfirmPassword.current.value
    )
      return setError(
        `Os campos 'Nova Senha' e 'Confirmar Senha' devem ser iguais.`
      );

    const token = localStorage.getItem("token");
    updateSettings(
      {
        email: inputEmail.current.value,
        password: inputNewPassword.current.value
          ? inputNewPassword.current.value
          : null,
      },
      token
    )
      .then((result) => {
        if (result) {
          setError("");

          inputNewPassword.current.value = "";
          inputConfirmPassword.current.value = "";
          return setSuccess(`Definições guardadas com sucesso!`);
        } else {
          setSuccess("");
          return setError(`Não é possível atualizar as definições.`);
        }
      })
      .catch((err) => {
        console.error(err.response ? err.response.data : err.message);
        return setError(`Não é possível atualizar as definições.`);
      });

    updateEmpresa(
      {
        morada: inputMorada.current.value,
        localidade: inputLocalidade.current.value,
        codpostal: inputCodigoPostal.current.value,
      },
      token
    )
      .then((result) => {
        if (result) {
          setError("");
          return setSuccess(`Definições guardadas com sucesso!`);
        } else {
          setSuccess("");
          return setError(`Não é possível atualizar as definições.`);
        }
      })
      .catch((err) => {
        console.error(err.response ? err.response.data : err.message);
        return setError(`Não é possível atualizar as definições.`);
      });
  }

  return (
    <React.Fragment>
      <Menu />
      <main className="content">
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
          <div className="d-block mb-4 mb-md-0">
            <h1 className="h4">Definições</h1>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card card-body border-0 shadow mb-4">
              <form>
                <h2 className="h5 mb-4">Informação sobre o utilizador</h2>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <div className="form-group">
                      <label htmlFor="email">E-mail</label>
                      <input
                        ref={inputEmail}
                        className="form-control"
                        id="email"
                        type="email"
                        placeholder="utilizador@empresa.pt"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <div>
                      <label htmlFor="newPassword">Nova Senha</label>
                      <input
                        ref={inputNewPassword}
                        className="form-control"
                        id="newPassword"
                        type="password"
                        placeholder="Introduza a sua nova senha"
                      />
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div>
                      <label htmlFor="confirmPassword">Confirmar Senha</label>
                      <input
                        ref={inputConfirmPassword}
                        className="form-control"
                        id="confirmPassword"
                        type="password"
                        placeholder="Introduza a sua nova senha de novo"
                      />
                    </div>
                  </div>
                </div>

                <h2 className="h5 mb-4">Informação sobre a empresa</h2>

                <div className="row">
                  <div className="col-sm-12 mb-3">
                    <div className="form-group">
                      <label htmlFor="nomeEmpresa">Designação</label>
                      <input
                        ref={inputNomeEmpresa}
                        className="form-control"
                        id="nomeEmpresa"
                        type="text"
                        placeholder="Designação"
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-12 mb-3">
                    <div className="form-group">
                      <label htmlFor="moradaEmpresa">Morada</label>
                      <input
                        ref={inputMorada}
                        className="form-control"
                        id="moradaEmpresa"
                        type="text"
                        placeholder="Morada da empresa"
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <div>
                      <label htmlFor="codpostal">Código postal</label>
                      <input
                        ref={inputCodigoPostal}
                        className="form-control"
                        id="codpostal"
                        type="text"
                        placeholder="Código postal"
                      />
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div>
                      <label htmlFor="localidade">Localidade</label>
                      <input
                        ref={inputLocalidade}
                        className="form-control"
                        id="localidade"
                        type="text"
                        placeholder="Localidade"
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="d-flex justify-content-between flex-wrap flex-md-nowrap">
                    <div className="col-sm-3">
                      <button
                        className="btn btn-gray-800 mt-2 animate-up-2"
                        type="submit"
                        onClick={handleFormSubmit}
                      >
                        Guardar
                      </button>
                    </div>
                    {error && (
                      <div className="alert alert-danger mt-2 col-9 py-2">
                        {error}
                      </div>
                    )}
                    {success && (
                      <div className="alert alert-success mt-2 col-9 py-2">
                        {success}
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </main>
    </React.Fragment>
  );
}

export default Settings;
